// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__1-5dN","ModalHide":"Modal_ModalHide__2q9jJ Modal_Modal__1-5dN"};